/* eslint-disable */
import React, { useCallback, useState } from "react";

import { Modal } from "antd";

import api from "../../services/api";
import { notifyError, notifySucces } from "../../utils/notifications";
import * as S from "./styles";
import { TErrorSSO, TModalData, User, EditUser, UpdateUser } from "./types";
import { usePermissions } from "../../Context/permissionContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthProvider";

const UserFluxConfirmationModal = ({
  setForceUpdate,
  isVisible,
  onCloseModal,
  userData,
  fetch,
  endpoint,
  modalTitle,
  title,
  description,
  method,
  editData,
  type,
  updateUser,
}: TModalData) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { fetchPermissions } = usePermissions();

  const { user: myUser, fetchMyUser } = useAuth();

  const handleManageData = useCallback(
    async (data: User | EditUser, update: UpdateUser) => {
      setIsLoading(true);

      try {
        let response;
        if (method === "patch") {
          response = await api.patch(endpoint, { user_id: data.id });
        }

        if (method === "delete") {
          response = await api.delete(endpoint, { user_id: data.id });
        }

        if (method === "put") {
          let normalizedData = data as EditUser;
          let formattedData: Partial<EditUser> = {
            username: normalizedData.username,
            login: normalizedData.login,
            email: normalizedData.email,
            cpf: normalizedData.cpf,
            password: normalizedData.password,
            store: normalizedData.store,
            role: normalizedData.role,
            id: normalizedData.id,
          };

          if (
            normalizedData?.merchant?.from?.id !==
            normalizedData?.merchant?.to?.id
          ) {
            formattedData = {
              ...formattedData,
              merchant: normalizedData.merchant,
            };
          }
          response = await api.put(endpoint, formattedData);

          setIsLoading(false);
          navigate(update?.redirectUrl || "/usuario");

          if (update.myUser?.id === (data as EditUser).id) {
            update.updateUser({
              ...update.myUser,
              store: (data as EditUser).store,
            });
          }

          fetchPermissions();
        }

        if (
          response.statusCode === 200 ||
          response.message.includes("sucesso")
        ) {
          notifySucces(response.message, true);
          fetch();
          if (method === "put" && myUser?.id === data.id) {
           await fetchMyUser(); 
          }
          return;
        }

        if (response.statusCode === 409) {
          notifyError(response.message, "ERROR_HIGHLIGHT", false, true);
          return;
        }
      } catch (error) {
        const err = error as TErrorSSO;
        notifyError(err.message, "ERROR_HIGHLIGHT", false, true);
      } finally {
        setIsLoading(false);
        onCloseModal(false);
      }
    },
    []
  );

  return (
    <Modal
      title={<span style={{ fontWeight: "bold" }}>{modalTitle}</span>}
      visible={isVisible}
      onCancel={() => onCloseModal(false)}
      style={{
        borderRadius: "8px",
      }}
    >
      <S.Container>
        <S.TitleWrapper>
          <S.Title>{title}</S.Title>
          <S.Description>{description}</S.Description>
        </S.TitleWrapper>
        <S.ButtonWrapper>
          <S.CancelButton onClick={() => onCloseModal(false)}>
            Cancelar
          </S.CancelButton>

          <S.ActivateSSOButton
            onClick={() => {
              handleManageData(
                type === "update" ? editData : userData,
                updateUser
              );
              type !== "update" && setForceUpdate();
            }}
          >
            {isLoading && <S.Loader />} Confirmar
          </S.ActivateSSOButton>
        </S.ButtonWrapper>
      </S.Container>
    </Modal>
  );
};

export default UserFluxConfirmationModal;
